import { FieldId } from '../../../../gk-dynamic-list/services/dictionary/dictionary.model';
import {
  FormlyBaseFormConfig,
  FormlyBaseFormExpressions,
  FormlyExtendedControlToOverride,
  FormlyExtendedPropertyToOverride,
} from '../../../../services/formly/formly-base-config/formly-base-config.model';

export enum LandUseClassFormControlName {
  LandUseClass = 'landUseClass',
}

export class LandUseClassFormModel {
  constructor(public landUseClass: FieldId[]) {}

  static getEmptyModel(): LandUseClassFormModel {
    return new this([]);
  }
}

export const landUseClassFormModel = LandUseClassFormModel.getEmptyModel();

export type LandUseClassFormExpressions =
  FormlyBaseFormExpressions<LandUseClassFormControlName>;

export class LandUseClassFormControlToOverride extends FormlyExtendedControlToOverride<LandUseClassFormControlName> {
  constructor(
    controlName: LandUseClassFormControlName,
    properties: LandUseClassFormExtendedPropertyToOverride[],
  ) {
    super(controlName, properties);
  }
}
export class LandUseClassFormExtendedPropertyToOverride extends FormlyExtendedPropertyToOverride<LandUseClassFormControlName> {
  constructor(pathToProperty: string[], value: any) {
    super(pathToProperty, value);
  }
}

export class LandUseClassFormConfig extends FormlyBaseFormConfig<LandUseClassFormControlName> {
  constructor(
    fieldsToHide: LandUseClassFormControlName[] = [],
    propertiesToOverride: LandUseClassFormExpressions = {},
    extendedPropertiesToOverride?: LandUseClassFormControlToOverride[],
  ) {
    super(fieldsToHide, propertiesToOverride, extendedPropertiesToOverride);
  }
}
